import { SphereAppCategoryListItem } from '../types/app-category-list-item';
import { SphereAppCategory } from './app-categories';

export const SphereAppCategories: SphereAppCategoryListItem[] = [
    // {
    //     category: SphereAppCategory.MarketDataMonitoring,
    //     priority: 0,
    //     logoSvg: DataInsightsApp.APP.data.logoSvg,
    //     backgroundAccentColor: DataInsightsApp.APP.data.cardBackground
    // },
    // {
    //     category: SphereAppCategory.MarketDataEntitlements,
    //     priority: 0,
    //     logoSvg: CriticalListsApp.APP.data.logoSvg,
    //     backgroundAccentColor: CriticalListsApp.APP.data.cardBackground
    // },
    // {
    //     category: SphereAppCategory.CustomDataAndAutomation,
    //     priority: 0,
    //     logoSvg: DataManagementApp.APP.data.logoSvg,
    //     backgroundAccentColor: DataManagementApp.APP.data.cardBackground
    // },
    // {
    //     category: SphereAppCategory.ForwardCurves,
    //     priority: 0,
    //     logoSvg: CurveBuilderApp.APP.data.logoSvg,
    //     backgroundAccentColor: CurveBuilderApp.APP.data.cardBackground
    // },
    // {
    //     category: SphereAppCategory.AdministrationAndConfigurationTools,
    //     priority: 2,
    //     logoSvg: AdministrationApp.APP.data.logoSvg,
    //     backgroundAccentColor: AdministrationApp.APP.data.cardBackground
    // }
];
